import { render, staticRenderFns } from "./brainCardiovascularPostProcessing.vue?vue&type=template&id=091453b4"
import script from "./brainCardiovascularPostProcessing.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularPostProcessing.vue?vue&type=script&lang=js"
import style0 from "./brainCardiovascularPostProcessing.vue?vue&type=style&index=0&id=091453b4&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091453b4')) {
      api.createRecord('091453b4', component.options)
    } else {
      api.reload('091453b4', component.options)
    }
    module.hot.accept("./brainCardiovascularPostProcessing.vue?vue&type=template&id=091453b4", function () {
      api.rerender('091453b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularPostProcessing.vue"
export default component.exports